
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1em","height":"1em","fill":"currentColor","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M2 7.702a2 2 0 01.438-1.25L5.1 3.126A3 3 0 017.442 2h9.116a3 3 0 012.343 1.126l2.66 3.326A2 2 0 0122 7.702V19a3 3 0 01-3 3H5a3 3 0 01-3-3V7.702zM7.442 4h9.116a1 1 0 01.781.375l1.775 2.219a.25.25 0 01-.195.406H5.08a.25.25 0 01-.195-.406l1.775-2.219A1 1 0 017.441 4zm5.56 7a1 1 0 00-2 0v5.086l-.795-.795a1 1 0 00-1.414 1.414l1.795 1.795a2 2 0 002.828 0l1.791-1.79a1 1 0 00-1.414-1.415l-.791.79V11z"}})])
          )
        }
      }
    